import { IContextMenu } from "../../phan-he-tiep-nhan-thanh-toan/models/ModelTabDSDangKy";

export const CODE_CONTEXT_TAB_XET_NGHIEM = {
  CHUYEN_PHONG_THUC_HIEN: "CPTH",
  BO_DICH_VU_KHONG_LAM: "BDVKL",
  TRA_KET_QUA_SAU_KHI_XU_TRI: "TKQSKXT",
  THAY_THE_DICH_VU_KHAC: "TTDVK",
  SUA_NGAY_TRA_KET_QUA: "SNTKQ",
  SUA_CHAN_DOAN_BENH: "SCDB",
  PHIEU_CHI_DINH: "phieuChiDinh",
  PHIEU_KHAM_BENH: "phieuKhamBenh",
  PHIEU_KET_QUA_CHAN_DOAN_HINH_ANH: "phieuKQCDHA",
  PHIEU_XET_NGHIEM_VI_SINH: "phieuXetNghiemViSinh",
  HUY_GUI_PHIEU: "huyGuiPhieu",
  XOA_PHIEU: "xoaPhieu",
  GUI_PHIEU: "guiPhieu",
  CHUYEN_NGAY_Y_LENH: "CNYL",
  CHUYEN_PHIEU_DIEU_TRI: "CPDT",
  CHUYEN_NGUOI_CHI_DINH: "CNCD",
  DS_PHIEU: "dsPhieu",
  DS_DICH_VU: "dsDICHVU",
  HUY_CONG_KHAM: "HUY_CONG_KHAM",
}

export const listContextXetNghiem: IContextMenu[] = [
  {
    title: "Phiếu thực hiện"
  },
  {
    code: "phieuChiDinh",
    name: "In phiếu chỉ định"
  },
  {
    code: "CPTH",
    name: "Chuyển phòng thực hiện"
  },
  {
    code: "BDVKL",
    name: "Bỏ dịch vụ không làm"
  },
  {
    code: "TKQSKXT",
    name: "Trả kết quả sau khi xử trí"
  },
  {
    title: "Thay thế dịch vụ"
  },
  {
    code: "TTDVK",
    name: "Thay thế dịch vụ khác"
  },
  {
    title: "Công cụ"
  },
  {
    code: "SNTKQ",
    name: "Sửa ngày trả kết quả"
  },
  {
    code: "SCDB",
    name: "Sửa chẩn đoán bệnh"
  }
]

export const listContextPhieuXetNghiem: IContextMenu[] = [
  {
    code: "CNYL",
    name: "Chuyển ngày y lệnh"
  },
  {
    code: "CPDT",
    name: "Chuyển phiếu điều trị"
  },
  {
    code: "CNCD",
    name: "Chuyển người chỉ định"
  },
]

export const listContextPhieuChuyenKhoa: IContextMenu[] = [
  {
    code: "CNYL",
    name: "Chuyển ngày y lệnh"
  },
  {
    code: "CPDT",
    name: "Chuyển phiếu điều trị"
  },
]


export const listContextVatTu: IContextMenu[] = [
  {
    title: "Dịch vụ"
  },
  {
    code: "chonStent",
    name: "Chọn Stent",
    children: [
      {
        code: "kpStent",
        name: "(Không phải Stent)"
      },
      {
        code: "lan1",
        name: "Lần 1"
      },
      {
        code: "lan2",
        name: "Lần 2"
      },
      {
        code: "lan3",
        name: "Lần 3"
      },
    ]
  },
  {
    code: "SCDB",
    name: "Sửa chẩn đoán bệnh"
  }
]

export const listContextDichVuCongKham: IContextMenu[] = [
  {
    code: "HUY_CONG_KHAM",
    icon: <i className="bi bi-x-lg text-danger" />,
    name: "Hủy công khám"
  },
]